'use client';

import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { Button } from './button';

interface SaveBarProps {
  message?: ReactNode;
  className?: string;
  busy?: boolean;
  onDiscard: () => void;
  onSave: () => void;
  discardLabel?: string;
  saveLabel?: string;
}

/**
 * Sticky footer for a form that saves as a whole. Render it only while there
 * is something to save, so its presence is the unsaved-changes signal.
 */
export function SaveBar({
  message = 'Unsaved changes.',
  className,
  busy = false,
  onDiscard,
  onSave,
  discardLabel = 'Discard',
  saveLabel = 'Save',
}: SaveBarProps) {
  return (
    <div
      className={cn(
        'corner-brand sticky bottom-4 z-10 flex items-center gap-3 border border-zinc-700 bg-zinc-900 px-4 py-3 shadow-lg shadow-black/40',
        className
      )}
    >
      <span className="text-sm text-zinc-300">{message}</span>
      <span className="ml-auto flex items-center gap-1.5">
        <Button disabled={busy} onClick={onDiscard}>
          {discardLabel}
        </Button>
        <Button variant="primary" loading={busy} onClick={onSave}>
          {saveLabel}
        </Button>
      </span>
    </div>
  );
}
